var map = {
	"./X33-Mall_small.jpg": 681,
	"./all.svg": 682,
	"./apple-watch.png": 683,
	"./b-headphone.png": 684,
	"./coin.svg": 685,
	"./delete-btn.svg": 686,
	"./iphone-pink.png": 687,
	"./love.svg": 688,
	"./mall-banner-cn.jpg": 689,
	"./mall-banner-id.jpg": 690,
	"./mall-banner-ms.jpg": 691,
	"./mall-banner.jpg": 692,
	"./mobile-bg.jpg": 693,
	"./price-high.svg": 694,
	"./price-low.svg": 695,
	"./shopping-cart.svg": 696,
	"./star.svg": 697
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170;